module.exports=function anonymous(obj,microTemplate
) {
var p=[],print=function(){p.push.apply(p,arguments);};with(obj){p.push(' <div id="access-level-nav" class="settings-sub-wrapper"></div>');}return p.join('');
}